import { EAppActionTypes, IAppStoreAction } from '../actions'
import { IToursFilter } from '../types';
import _ from 'lodash';

export default (state: IToursFilter, { type, filter }: IAppStoreAction) => {
	switch (type) {
		case EAppActionTypes.SetFilter:
			if (!filter || filter.hasCoupons === state.hasCoupons && _.xor(filter.categories, state.categories).length === 0) return state
			return filter
		case EAppActionTypes.ResetFilter:
			return {
				categories: [],
            	hasCoupons: false
			}
		default:
			return state
	}
}